module.exports = __webpack_public_path__ + "img/fear-and-greed-dark.9a3e7eb.png";